import React from "react";
import PropTypes from "prop-types";
import {message} from "antd";
import {BaseComponent} from '@cm-sites-webber/components';
import ImageView from "../../formItemTemplate/components/imgView";

/**
 * uploadRecord组件
 */
export default class UploadRecord extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            loading: false,
            value: {},
            customInfo: {},
        };

        this.imageRef = React.createRef();
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.updateValue();
        this.getSystemInfo();
    }

    getSystemInfo = () => {
        const url = '/cm-sites-media-consumer/system/getCustomInfo';
        new Promise((resolve,reject) => {
            this.request({
                url,
                method: 'get',
                callBack: (res) => {
                    resolve(res)
                },
                errorCallBack:(err)=> {
                    reject(err)
                }
            })
        }).then((res) => {
            let customInfo = {};
            if(res) {
                customInfo = res;
            }
            this.setState({
                customInfo
            })
        }).catch((err) => {
            message.destroy();
            message.error(err);
        })
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(UploadRecord.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }


    viewPic = (file) => {
        let suffix = file.name.split(".").at(-1);
        if(suffix === "pdf") {
            window.open(file.path);
        }else {
            this.imageRef.current.show();
        }
    }

    render() {
        const {value, fieldProps} = this.state;
        return (
            <>
                <div style={{flexGrow: 0}}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                    }}>
                        <a title={value?.name} style={{
                            overflow: "hidden",
                            display: "block",
                            maxWidth: fieldProps.col === 12 ? "290px" : "660px",
                            textOverflow: "ellipsis",
                            lineClamp: 1,
                            whiteSpace: "nowrap",
                            maxLength: 17,
                            fontSize: 14
                        }} onClick={() => {
                            this.viewPic(value);
                        }}>{value?.name}</a>
                        <ImageView ref={this.imageRef} path={value?.path}/>
                    </div>
                </div>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}

UploadRecord.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

UploadRecord.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: ()=>{}
}